import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
import {
  HeaderSkeleton,
  PaginationSkeleton,
  TableSkeleton,
} from "../Skelton/Skelton";
const EditDepartment = () => {
  const { baseUrl, name, setName, staffs, depId, openToast, setDepartments, fetchDepartments, user, departments } =
  useGlobalContext()  
  
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const recordsPerPage = 10

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      const result = await fetchDepartments(currentPage)
      setDepartments(result.data)
      setTotalPages(result?.totalPages)
      setTotalRecords(result.totalRecords)
      setIsLoading(false)
    }
    fetchData()
  }, [currentPage])

  const filteredStaffs = staffs?.filter((staff) => staff?.staffDetails?.department?.id == name?.id)

  

  async function updateDepartment() {
    try {
      setIsLoading(true);
      const response = await fetch(baseUrl + "department/" + depId, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ departmentName: name?.department_name}), // send the formatted data
      });
      console.log(response)
      const result = await response.json();
      if (response.status === 200) {
        navigate("/department-details");
        openToast("Update Department Successfully", "success");
        fetchDepartments();
      } else {
        openToast("An error occurred", "error");
      }
    } catch (error) {
      openToast("error", error);
    } finally {
      setIsLoading(false);
    }
  }


  useEffect(() => {
    if (name === "" || depId == "") {
      navigate("/department-details");
    }
  }, []);

  const handleNext = () => {
    console.log("onClick")
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  // 🔹 Handle Previous Page Click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className="flex md:flex-row flex-col gap-1">
      <div className="mb-3 pr-2 pb-4 pl-[10px] w-[100%] sm:w-[100%] md:w-[100%] lg:w-[50%] addnewrole">
        <h2 className="mt-[20px]">Edit Department</h2>

        <div className="bg-[#fff] shadow-cs mt-[20px] p-3 rounded-lg w-[100%] sm:w-[100%] md:w-[100%]">
          <label>Department Name</label>
          <br />
          <input
            type="text"
            className="mt-2 pr-[7px] pl-3 border border-1 rounded-md focus:outline-none w-[100%] h-[43px] text-[#aeabab] text-[15px]"
            value={name?.department_name}
            onChange={(e) => setName(e.target.value)}
          />
          <table className="mt-5 border border-1 w-[100%]">
            <thead className="border border-1">
              <th className="p-2 border-r-[1px] font-medium text-left">
                Features
              </th>
              <th className="p-2 font-medium text-left">Capabilities</th>
            </thead>
            <tbody className="table-body-set">
              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Clients
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="client"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="client1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="client2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="client3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="client3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Projects
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="project"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="project1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="project2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="project3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="project3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Report
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="report"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="report"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="report1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="report1"
                  >
                    {" "}
                    View Timesheets Report
                  </label>
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Staff Role
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staffrole"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="staffrole1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staffrole2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staffrole3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staffrole3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Setting
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="setting"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="setting"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="setting1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="setting1"
                  >
                    {" "}
                    View Timesheets Report
                  </label>
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Staff{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staff"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="staff1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staff2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="staff3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="staff3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="task"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="task1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="task2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="task3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="task3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px]">
                  Sub Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="subtask"
                  >
                    View Global
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask1"
                    name="vehicle2"
                    value="Car"
                  />
                  <label
                    className="ml-2 text-[#64748b] text-[13px] cursor-pointer"
                    for="subtask1"
                  >
                    {" "}
                    Create
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask2"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="subtask2"
                  >
                    Edit
                  </label>
                  <br />
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="subtask3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="subtask3"
                  >
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              <tr className="border border-1">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[14px] whitespace-nowrap">
                  Chat Module{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    id="chat"
                    name="vehicle1"
                    value="Bike"
                  />
                  <label
                    className="ml-3 text-[#64748b] text-[13px] cursor-pointer"
                    for="chat"
                  >
                    Grant Access
                  </label>
                  <br />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-end gap-2 mt-3">
            <Link to="/department-details " className="flex items-center first-btn">
              Cancel
            </Link>
            <button
              className={`second-btn ${isLoading == true ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={updateDepartment}
            >
              Update
            </button>
          </div>
        </div>
      </div>

      <div className="w-[100%] sm:w-[100%] md:w-[100%] lg:w-[50%] staff-member">
        <h2 className="mt-[20px]">Staff members using this Department</h2>

        <div className="bg-[#fff] shadow-cs mt-[20px] mb-[40px] md:mb-0 p-2 rounded-lg">
          <div className="">
            <h2 className="bg-[#fff] shadow-cs mb-2 p-2 border border-t-1 border-r-0 border-b-1 border-l-0 rounded-md">
              Departments
            </h2>

            <div className="title">
              {filteredStaffs && filteredStaffs.length > 0 ? (
                filteredStaffs.map((item, index) => (
                  <h3 key={index} className="px-[5px] py-[7px] border-b text-grey-400">
                    {index + 1}. {item?.name}
                  </h3>
                ))
              ) : (
                <p className="px-[5px] py-[7px] text-center text-red-500 ">No staff members in this department.</p>
              )}
            </div>

            {filteredStaffs && filteredStaffs.length > 0 && (
              <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-4 w-full">
                {isLoading ? (
                  <PaginationSkeleton />
                ) : (
                  <>
                    <p className="text-gray-500 text-sm">
                      Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                      {Math.min(currentPage * recordsPerPage, filteredStaffs.length)} of {filteredStaffs.length} entries
                    </p>
                    <div className="flex gap-2 p-0 border rounded-md pagination">
                      <button
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                        className={`px-3 py-2 text-xs ${currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""}`}
                      >
                        Previous
                      </button>
                      <span className="flex items-center bg-purple-900 px-3 text-white text-xs">{currentPage}</span>
                      <button
                        onClick={handleNext}
                        disabled={currentPage >= Math.ceil(filteredStaffs.length / recordsPerPage)}
                        className={`px-3 py-2 text-xs ${currentPage >= Math.ceil(filteredStaffs.length / recordsPerPage) ? "opacity-40 cursor-not-allowed" : ""}`}
                      >
                        Next
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDepartment;
